import React, { useEffect, useState, forwardRef } from "react";
import "./InputBox.css";
import { useTranslation } from "react-i18next";

const InputBox = forwardRef(
  (
    {
      label,
      defaultValue = "",
      onChange,
      onKeyPress,
      type = "text",
      style,
      error,
      readOnly = false,
      disabled = false, // ✅ new prop
      className = "",
      border = "",
      maxQuantity,
      isPrice = false,
      isNumber = false,
      isDecimal = false,
      prefix = "",
      important = false,
    },
    ref,
  ) => {
    const [value, setValue] = useState(defaultValue);
    const [errors, setErrors] = useState([]);
    const { t } = useTranslation();

    const handleChange = (event) => {
      if (disabled) return; // ✅ block input if disabled

      let newValue = event.target.value;

      // Empty allowed (so user can delete & retype)
      if (newValue === "") {
        setValue(newValue);
        if (onChange) onChange(event);
        return;
      }

      // ✅ Price input (2 decimals only)
      if (isPrice) {
        const regex = /^\d+(\.\d{0,2})?$/;
        if (!regex.test(newValue)) return;
      }

      // ✅ Whole numbers only
      if (isNumber) {
        const regex = /^\d+$/;
        if (!regex.test(newValue)) return;
      }

      // ✅ Decimal allowed
      if (isDecimal) {
        const regex = /^\d*\.?\d*$/;
        if (!regex.test(newValue)) return;
      }

      // ✅ Max quantity check
      if (maxQuantity !== undefined) {
        const regex = /^\d+(\.\d{0,4})?$/;
        if (!regex.test(newValue)) return;
        const numValue = parseFloat(newValue);
        if (parseFloat(maxQuantity) === 0) {
          // Only "0" is allowed if maxQuantity = 0
          if (newValue !== "0") return;
        } else {
          if (numValue > parseFloat(maxQuantity)) return;
        }
      }

      setValue(newValue);
      if (onChange) onChange(event);
    };

    useEffect(() => {
      setValue(defaultValue);
    }, [defaultValue]);

    const displayErrors = error ? [error] : errors;

    return (
      <div
        className={`input-box-container posrel ${className} ${disabled ? "disabled" : ""} ${prefix ? "currency" : ""}`}
      >
        {prefix && (
          <span className="currency-symbol common-text ftw-5">{prefix}</span>
        )}
        <input
          ref={ref}
          className={`${prefix ? "currency-input-box" : "input-box"} common-text ftw-4
                    ${type === "date" ? "input-box-with-icon" : ""}
                    ${displayErrors.length > 0 && !prefix ? "input-error" : ""}
                    ${border}`}
          style={style}
          type={type}
          value={value}
          onChange={handleChange}
          onKeyPress={onKeyPress}
          placeholder=" "
          readOnly={readOnly}
          disabled={disabled}
        />
        <label
          className={`${prefix ? "currency-label" : "input-label"} common-text ftw-4 ${value ? "has-value" : ""}`}
        >
          {t(label)}
          {important && <span className="required-asterisk">*</span>}
        </label>
      </div>
    );
  },
);

// Add display name for better debugging
InputBox.displayName = "InputBox";

export default InputBox;

